import { useNavigate } from "react-router-dom";
import { ArrowRight, Lightning } from "@phosphor-icons/react";

export function CtaSection() {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="relative rounded-3xl bg-gradient-to-br from-primary-500 via-primary-600 to-[#3B7AE0] px-8 py-16 sm:px-16 sm:py-20 overflow-hidden">
          {/* Background patterns */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 h-48 w-48 rotate-45 border border-white/30" />
            <div className="absolute bottom-0 right-0 h-64 w-64 rotate-12 border border-white/20 rounded-3xl" />
            <div className="absolute top-1/2 left-1/3 h-32 w-32 -rotate-12 border border-white/25" />
          </div>
          <div className="absolute top-0 right-0 h-75 w-75 rounded-full bg-white/10 blur-[80px]" />

          <div className="relative mx-auto max-w-2xl text-center">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-semibold text-white backdrop-blur-sm">
              <Lightning size={16} weight="fill" />
              Start managing smarter
            </div>

            <h2 className="mt-6 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Your team deserves better than spreadsheets and status meetings
            </h2>

            <p className="mt-6 text-lg text-blue-100/90 leading-relaxed">
              Join 2,400+ teams using Opero to ship faster, reduce burnout, and
              let AI handle the busywork.
            </p>

            <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
              <button
                onClick={() => navigate("/signup")}
                className="inline-flex items-center gap-2 rounded-xl bg-white px-8 py-3.5 text-sm font-semibold text-primary-500 shadow-xl transition-all duration-200 hover:shadow-2xl hover:scale-[1.02]"
              >
                Start Free Trial
                <ArrowRight size={16} weight="bold" />
              </button>
              <a
                href="#"
                className="inline-flex items-center gap-2 rounded-xl border border-white/30 bg-white/10 px-8 py-3.5 text-sm font-semibold text-white backdrop-blur-sm transition-all duration-200 hover:bg-white/20"
              >
                Book a Demo
              </a>
            </div>

            <p className="mt-6 text-sm text-blue-200/70">
              1-month free trial. No credit card required. Cancel anytime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
